import { SAVED_VIEW_REQUIRES_CREATED_DATE_ERROR } from './const';
import { SavedViewDetailsParams } from './types';

export type GetSavedViewsQueryKeyType = readonly ['savedViews'];

export type GetSavedViewsListQueryKeyType = readonly [
  ...GetSavedViewsQueryKeyType,
  'list',
];

export type GetSavedViewDetailsQueryKeyType = readonly [
  ...GetSavedViewsQueryKeyType,
  number,
];

export type GetUpdateSavedViewMutationKeyType = readonly ['updateSavedView'];

export const getSavedViewsQueryKey = (): GetSavedViewsQueryKeyType => [
  'savedViews',
];

export const getSavedViewsListQueryKey = (): GetSavedViewsListQueryKeyType => [
  ...getSavedViewsQueryKey(),
  'list',
];

export const getSavedViewDetailsQueryKey = (
  params: SavedViewDetailsParams,
): GetSavedViewDetailsQueryKeyType => [
  ...getSavedViewsQueryKey(),
  params.viewId,
];

export const getUpdateSavedViewMutationKey =
  (): GetUpdateSavedViewMutationKeyType => ['updateSavedView'];

export const getUpdateOrCreateSavedViewErrorMessage = (
  fallbackMessage: string,
  error: unknown,
) => {
  if (
    error instanceof Error &&
    error.message === SAVED_VIEW_REQUIRES_CREATED_DATE_ERROR
  ) {
    return 'View requires a Date Created filter';
  } else {
    return fallbackMessage;
  }
};
